import {
    executeJsonGetMethod,
    executeJsonPostMethod
} from '../api/rest/restApiUtils'

export function getDiscover(lang?: string) {
    const params = lang ? `?lang=${lang}` : ''
    return executeJsonGetMethod(`/v1/done-card-list${params}`).then((resp) => resp.data)
}

export function getListsByCategory(categoryId: number, page = 0, size = 20, level?: string, lang?: string) {
    const params = new URLSearchParams({page: String(page), size: String(size)})
    if (level) params.append('level', level)
    if (lang) params.append('lang', lang)
    return executeJsonGetMethod(`/v1/done-card-list/category/${categoryId}?${params}`).then((resp) => resp.data)
}

export function searchLists(query?: string, sourceLanguage?: string, level?: string, page = 0, size = 20) {
    const params = new URLSearchParams({page: String(page), size: String(size)})
    if (query) params.append('query', query)
    if (sourceLanguage) params.append('sourceLanguage', sourceLanguage)
    if (level) params.append('level', level)
    return executeJsonGetMethod(`/v1/done-card-list/search?${params}`).then((resp) => resp.data)
}

export function getFullList(id: number) {
    return executeJsonGetMethod(`/v1/done-card-list/list/${id}`).then((resp) => resp.data)
}

export function getPreview(id: number) {
    return executeJsonGetMethod(`/v1/done-card-list/list/${id}/preview`).then((resp) => resp.data)
}

export function getReferences(lang?: string) {
    const params = lang ? `?lang=${lang}` : ''
    return executeJsonGetMethod(`/v1/done-card-list/references${params}`).then((resp) => resp.data)
}

export function copyListToUser(id: number, translationLang = 'RUSSIAN') {
    return executeJsonPostMethod(`/v1/done-card-list/list/${id}/copy?translationLang=${translationLang}`, undefined)
}